import TicketPage from './pages/TicketPage.vue'
import TicketInstalacaoPage from './pages/TicketInstalacaoPage.vue'
import ImportarTicketsLotePage from './pages/ImportarTicketsLotePage.vue'

const routes = [
  {
    path: 'ticket-recuperacao',
    name: 'ticket',
    component: TicketPage,
    meta: { moduloId: 1 }
  },
  {
    path: 'ticket-instalacao',
    name: 'ticket-instalacao',
    component: TicketInstalacaoPage,
    meta: { moduloId: 2 }
  },
  {
    path: 'ticket-recuperacao-importar',
    name: 'ticket-importar-lote',
    component: ImportarTicketsLotePage,
    meta: { moduloId: 1 }
  }
];

export default routes;